import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Twitter",
  "use": "Twitter-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"Twitter\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19 4H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1Zm-1.64 2-4.372 5.081L17.742 18h-3.497l-3.2-4.66L7.034 18H6l4.584-5.328L6 6h3.496l3.032 4.412L16.323 6h1.036Zm-6.255 6.066.464.664 3.164 4.526h1.59l-3.876-5.546-.464-.664L9 6.78H7.41l3.695 5.286Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol